import SmallBadge from "@/common/components/SmallBadge";
import { AuctionProposalLeadValueProps } from "@/features/maintenance/features/establishmentChoice/features/auctions/types/auctionProposalLeadValue.type";
import { format } from "date-fns";
import { CalendarClockIcon } from "lucide-react";

const DiagnosticProposalLeadValue = ({ proposal, tooltipId }: AuctionProposalLeadValueProps) => {
  const estimatedCompletionDate = proposal.contents?.estimated_completion_date;

  if (!estimatedCompletionDate)
    return null;

  return (
    <SmallBadge
      data-tooltip-id={tooltipId}
      data-tooltip-content="Previsão de conclusão"
      LeftIcon={CalendarClockIcon}
      text={format(new Date(estimatedCompletionDate), "dd/MM HH:mm")}
      className="bg-success-op text-success-tertiary"
    />
  );
}

export default DiagnosticProposalLeadValue;
